<app-widget-option [categories]="['INDICATORS']" [label]="'CUMULATIVE'">
    <div app-widget-option-content>
        <app-check [color]="color" [value]="widgetLayers.indicators[current].cumulative" (sendValue)="receiveCumulative($event)"></app-check>
    </div>
</app-widget-option>